import { gql } from '@apollo/client';

export const USER_DETAILS_QUERY = gql`
  query UserDetails {
    userDetails {
      email
      companyName
      avatar
      firstName
      lastName
      phoneNumber
      title
      industry
      companySize
      rateCard {
        id
        name
      }
    }
  }
`;

export const USER_STATUS_INDICATORS_QUERY = gql`
  query UserStatusIndicators {
    userStatusIndicators {
      hasAcceptedTerms
      hasValidSubscription
      subscriptionErrors {
        code
        data {
          actual
          expected
        }
      }
      hasFailedPayment
      currentPlan
      currentRecurringInterval
    }
  }
`;

export const ALL_USERS_QUERY = gql`
  query AllUsersQuery {
    users {
      id
      email
      companyName
      roles
      avatar
      plan
      stripeId
      lastLogin
      firstName
      lastName
      phoneNumber
      title
      industry
      companySize
      verificationToken
      verified
      resetToken {
        token
        expires
      }
      passwordReset
      createdAt
      disabled
      termsOfUse {
        lastAccepted
      }
      rateCard {
        id
        name
      }
      paymentType
    }
  }
`;
